import {createSelector, MemoizedSelector} from '@ngrx/store';
import {RaceClass} from '@app/rest-client/faxe/models/race-class';
import {getRaceClassState} from '@app/store/faxe/faxe-selectors';
import {selectAllRaceClass} from '@app/store/faxe/race-class/race-class.reducer';


export const selectRaceClassAll: MemoizedSelector<object, RaceClass[]> = createSelector(
  getRaceClassState,
  selectAllRaceClass
);

export const selectRaceClass = ():
  MemoizedSelector<object,RaceClass[]> =>
  createSelector(
    getRaceClassState,
    selectRaceClassAll,
    (state, all) => all
  );

export const selectRaceClassByRaceGuid = (raceGuid: string):
  MemoizedSelector<object, RaceClass[]> =>
  createSelector(
    getRaceClassState,
    selectRaceClassAll,
    (state, all) =>
      all.filter(raceClass => raceClass.raceGuid === raceGuid)
  );
